import type { JSX } from "react";
import { cn } from "./cn";
import { Icon } from "./Icon";

export interface AttachmentLabelProps {
  /** File name */
  readonly name: string;
  /** File size display */
  readonly size?: string;
  /** Extra className */
  readonly className?: string;
}

/**
 * A small attachment indicator with a file icon, name, and optional size.
 */
export function AttachmentLabel({ name, size, className }: AttachmentLabelProps): JSX.Element {
  return (
    <div className={cn("flex items-center gap-1.5 text-xs opacity-80", className)}>
      <Icon name="file" size={13} />
      <span>{name}</span>
      {size ? <span className="opacity-60">{size}</span> : null}
    </div>
  );
}
